<template>
  <ModalSmall :title="t('mobile_use')" @close="close">
    <div class="container-qr">
      <div class="qr-tit">
        <h1>{{ t('use_sconchat_on_phone') }}</h1>
        <p class="pdt-2">{{ t('description_use_qr') }}</p>
      </div>
      <AppTab v-model="activeTab" :tabs="tabs" />

      <div class="qr-img-wrap">
        <img class="qr-image" :src="qrCodeUrl" alt="qr_code_image" />
      </div>

      <div class="link-input">
        <span>{{ linkUrl }}</span>
        <button type="button" class="copy-btn" @click="copyLink">
          <IconCopy class="icon" />
        </button>
      </div>
    </div>
  </ModalSmall>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import AppTab from '@/components/domains/mobile/common/AppTab.vue';
import IconCopy from '@/components/jh-app/icons/IconCopy.vue';
import ModalSmall from '@/components/shared/composite/ModalSmall.vue';
import { useCallStore } from '@/stores/call';
import { AppTabButton } from '@/types/components';
import { IResponseMultiCallsDashboard } from '@/types/response';
const { t } = useI18n();

const { callInfo } = defineProps<{
  callInfo: IResponseMultiCallsDashboard;
}>();

const emit = defineEmits(['close']);

const callStore = useCallStore();

const isEmployeeCopied = ref(false);
const activeTab = ref<'guest' | 'host'>('guest');

const tabs = computed<AppTabButton[]>(() => {
  const isGuest = callStore.qrCodeInfo.qrCodeType.split('_').pop() === 'GUEST';
  return isGuest
    ? [{ label: t('for_guest'), value: 'guest' }]
    : [
        { label: t('for_guest'), value: 'guest' },
        { label: t('for_host'), value: 'host' },
      ];
});

// 통역방 URL 링크
const linkUrl = computed(() => {
  return activeTab.value === 'host' ? callInfo.employeeLinkUrl : callInfo.guestLinkUrl;
});

// QR 코드 이미지 URL
const qrCodeUrl = computed((): string => {
  return activeTab.value === 'host' ? callInfo.employeeQRCodeImageUrl : callInfo.guestQRCodeImageUrl;
});

// 링크 복사
const copyLink = async () => {
  try {
    await navigator.clipboard.writeText(linkUrl.value);
    isEmployeeCopied.value = true;
  } catch (err) {
    console.error('복사 실패:', err);
  }
};

const close = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.container-qr {
  width: 100%;
  .qr-tit {
    text-align: center;
    h1 {
      font-size: 1.25rem;
    }
    p {
      line-height: 130%;
      font-size: $font-size-psmall;
      color: $color-gray-100;
    }
  }
  .qr-img-wrap {
    max-width: 300px;
    max-height: 300px;
    width: 100%;
    height: 100%;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.wrapper-qr-image {
  background-color: var(--surface-gray-dimmer);
  border-radius: 8px;
  width: 10rem;
  overflow: hidden;
  display: inline-block;
}

.qr-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  mix-blend-mode: multiply;
}

.wrapper-button {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
}
</style>
